type ReloadBoxProps = {
  onClick?: () => any;
  text: string;
};

// 새로고침 안내상자
const ReloadBox = (props: ReloadBoxProps) => {
  const { onClick, text } = props;

  return (
    <div className="column center gap-12 click self-center" onClick={onClick}>
      <i className="icon-icon-refresh gray-500" style={{ fontSize: 48 }} />
      <span className="body2-500 gray-500">{text}</span>
    </div>
  );
};

export { ReloadBox };
